import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { pipe } from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import {
  setDateTitle,
  setNewTitleByCompanyShow,
  setTitleByGenreShow,
  setTitleByRegionShow,
  setTitleByReleaseDateShow,
  setTitleBySteamIdShow,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/titleSettingAtom';
import { STORERANK_METRICS_OPTIONS_LIST } from '@/pages/intelligence/_config/storeRank/config';
interface IParams {
  source_type?: any[];
  downloadType?: 'avg' | 'latest' | 'trend';
  key?: any;
  current_tab?: string;
}
interface TitleType {
  title: string;
  key: string;
}
const sourceTypeMap = {
  steam: 'steam',
  epic: 'epic',
  play_station: 'playstation',
  xbox: 'xbox',
  nintendo: 'nintendo',
};
const getSummarySheet = (params: Record<string, any>) => {
  const list: any[] = [
    ['Regions/Countries', params?.regions.join(',')],
    ['Date Start', params?.start_date],
    ['Date End', params?.end_date],
    ['Game Name', params?.new_style_donwload_file_name],
  ];
  return list;
};

const getColumn = (params: any, isTable = false) => {
  const list: TitleType[] = [];
  const { source_type = [], current_tab = 'avg' }: IParams = params || {};
  const pipeFront = pipe(
    setDateTitle(isTable),
    setNewTitleByCompanyShow(params.company_show),
    setTitleByGenreShow(params.genre_show),
    setTitleByReleaseDateShow(params.release_date_show),
    setTitleByRegionShow(1),
    setTitleBySteamIdShow(params.steam_id_show),
  );
  pipeFront(list);
  // eslint-disable-next-line @typescript-eslint/naming-convention

  const tabMap: any = {
    avg: 'Avg',
    latest: 'Latest',
    trend: '',
  };
  const filterSourceType = source_type
    ?.filter((item) => item !== undefined)
    ?.map((ele) => {
      return sourceTypeMap[ele as keyof typeof sourceTypeMap];
    });
  const filterData = STORERANK_METRICS_OPTIONS_LIST.filter((item) =>
    filterSourceType?.includes(item.dataSource),
  );
  filterData?.forEach((ele) => {
    list.push(
      {
        key: ele.value,
        title: `${isTable ? tabMap[current_tab] : ''} ${ele.downloadTitle}`,
      },
      {
        title: 'Change',
        key: `${ele.value}_growth_ratio`,
      },
    );
  });
  return list;
};
const getSource = (params: any) => {
  const { source_type = [] }: IParams = params || {};
  // debugger;
  const filterSourceType = source_type
    ?.filter((item) => item !== undefined)
    ?.map((ele) => {
      return sourceTypeMap[ele as keyof typeof sourceTypeMap];
    });
  const filterData = STORERANK_METRICS_OPTIONS_LIST.filter((item) =>
    filterSourceType?.includes(item.dataSource),
  );
  return filterData?.map((ele) => ele.value);
};
export default (params: Record<string, any>) => {
  console.debug('paramsparams', params);
  return {
    ...commonSetting,
    $$fileName: `${params?.new_style_donwload_file_name}(${params?.tableTotal}) Store Rank_${params?.start_date}_${params?.end_date}`,
    sheetName: ['Rank Trend', 'Rank Table'],
    dataKey: ['trends', 'list'],
    'Rank Trend': getColumn(params),
    'Rank Table': getColumn(params, true),
    fetchOnlyOnce: true,
    fParams: {
      ...params,
      entity_type: 'pc',
      source: getSource(params),
      regions: params?.regions_new || [],
      trend_regions: params?.regions_new || [],
      source_type: params.source_type?.filter((item: any) => item !== undefined && item !== null),
      ext_fields: {
        basic_info: {
          combined_id: params?.combine_id,
        },
      },
    },
    downloadApiParams: {
      unified_id: params?.unified_id,
      app_ids: params?.app_ids,
      region_type: params?.region_type,
      granularity: params?.date_type,
      start_date: params?.start_date,
      end_date: params?.end_date,
      order_source: params?.order_source,
      order: params?.order,
      b_last_date: params?.b_last_date,
      b_ratio_start_date: params?.b_ratio_start_date,
      entity_type: 'pc',
      source: getSource(params),
      regions: params?.regions_new || [],
      trend_regions: params?.regions_new || [],
      source_type: params.source_type?.filter((item: any) => item !== undefined && item !== null),
      ext_fields: {
        basic_info: {
          combined_id: params?.combine_id,
        },
      },
    },
    downloadFetchApi: '/api/v1/intelligence_pc/storeRank/pc_console',
    needBasicInfo: true,
    summarySheet: getSummarySheet(params),
  };
};
